class AbholStandort extends HTMLElement {
    static observedAttributes = ["changed"];
    static FEHLER_TEXT = "Verfügbarkeit konnte nicht geladen werden";

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "changed" && newValue === "true" && oldValue !== newValue) {
            this.render();
        }
    }

    render() {
        if (this.getAttribute("data-fehler") === "true") {
            this.renderFehler();
            return;
        }
        const status = this.getAttribute("data-abholstatus");
        const text = this.getAttribute("data-abholaussage");
        if (!status || !text) {
            return; // kein Treffer aus dem Batch -> leer lassen
        }

        if (status === "NACHBERECHNUNG_ERFORDERLICH") {
            this.renderAbfragenButton(text);
        } else {
            this.renderAussage(this.convertStatus(status), text);
        }
    }

    renderAbfragenButton(text) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "abholaussageAbfragen abholinfo";
        button.setAttribute("interaction", `abholaussageAbfragen${this.getAttribute("data-filial-id")}`);
        button.appendChild(this.statusIndicator("neutral", text));
        button.addEventListener("click", () => this.abholaussageAbfragen());
        this.replaceChildren(button);
    }

    renderAussage(state, text) {
        const paragraph = document.createElement("p");
        paragraph.className = "abholinfo";
        paragraph.appendChild(this.statusIndicator(state, text));
        this.replaceChildren(paragraph);
    }

    renderFehler() {
        this.renderAussage("neutral", AbholStandort.FEHLER_TEXT);
    }

    statusIndicator(state, text) {
        const span = document.createElement("span");
        span.className = "element-status-indicator abholinfo-text";
        span.setAttribute("data-test", "abhol-info");
        span.dataset.state = state;
        span.textContent = text; // textContent -> keine HTML-Injection
        return span;
    }

    async abholaussageAbfragen() {
        if (this.aktualisierungLaeuft) {
            return; // Doppelklick abfangen, solange ein Request laeuft
        }
        this.aktualisierungLaeuft = true;
        const button = this.querySelector("button");
        if (button) {
            button.disabled = true;
        }
        try {
            const matnr = this.getAttribute("data-matnr");
            const filialId = this.getAttribute("data-filial-id");
            const response = await fetch(
                `/lieferaussage/api/abholaussage/${encodeURIComponent(filialId)}/${encodeURIComponent(matnr)}`);
            if (!response.ok) {
                throw new Error(`Antwort nicht ok: ${response.status}`);
            }
            const { abholaussage, abholstatus } = await response.json();
            this.setAttribute("data-abholaussage", abholaussage);
            this.setAttribute("data-abholstatus", abholstatus);
            this.setAttribute("changed", "true"); // als fertig markieren -> spaetere Batch-Laeufe fassen es nicht mehr an
            this.renderAussage(this.convertStatus(abholstatus), abholaussage);
        } catch (error) {
            console.error("Abholaussage konnte nicht ermittelt werden:", error);
            this.setAttribute("data-fehler", "true");
            this.setAttribute("changed", "true"); // Fehleranzeige ebenfalls vor spaeterem Ueberschreiben schuetzen
            this.renderFehler();
        } finally {
            this.aktualisierungLaeuft = false;
        }
    }

    convertStatus(status) {
        switch (status) {
            case "VERFUEGBAR":
                return "positive";
            case "NICHT_VERFUEGBAR":
                return "negative";
            default:
                return "neutral"; // BALD_VERFUEGBAR (NACHBERECHNUNG wird als Button gerendert)
        }
    }
}

if (!customElements.get("abhol-standort")) {
    customElements.define("abhol-standort", AbholStandort);
}
